module.exports = __webpack_public_path__ + "img/lipu-2.e035b13b.png";